/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharing_OptionsInputs */

const en_sharing_options = /** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sharing Options`)
};

const id_sharing_options = /** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opsi Berbagi`)
};

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const es_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const fr_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const de_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const ja_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const zh_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const ar_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const it_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const ru_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const pt_sharing_options = en_sharing_options;

/** @type {(inputs: Sharing_OptionsInputs) => LocalizedString} */
const ko_sharing_options = en_sharing_options;

/**
* | output |
* | --- |
* | "Sharing Options" |
*
* @param {Sharing_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sharing_options = /** @type {((inputs?: Sharing_OptionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharing_OptionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharing_options(inputs)
	if (locale === "es") return es_sharing_options(inputs)
	if (locale === "fr") return fr_sharing_options(inputs)
	if (locale === "de") return de_sharing_options(inputs)
	if (locale === "ja") return ja_sharing_options(inputs)
	if (locale === "zh") return zh_sharing_options(inputs)
	if (locale === "ar") return ar_sharing_options(inputs)
	if (locale === "id") return id_sharing_options(inputs)
	if (locale === "it") return it_sharing_options(inputs)
	if (locale === "ru") return ru_sharing_options(inputs)
	if (locale === "pt") return pt_sharing_options(inputs)
	return ko_sharing_options(inputs)
});